import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { ChimeLogoSvg } from 'components/Svgs/ChimeLogo_125x36_Svg';

export function SuccessPageLayout({ children }) {
  return (
    <Container>
      <LogoContainer>
        <ChimeLogoSvg aria-label="Chime" />
      </LogoContainer>

      {children}
    </Container>
  );
}

SuccessPageLayout.propTypes = {
  children: PropTypes.node,
};

const Container = styled.div`
  padding: 1.5rem 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 20.5rem;
  margin: 0 auto;
`;

const LogoContainer = styled.div`
  margin: 0 auto;
  width: 4rem;
  height: 1.25rem;

  ${props => css`
    ${props.theme.media.tablet`
      width: 7.75rem;
      height: 2.25rem;
    `};
  `};
`;
